import React from 'react';
const stats = [{
  emoji: '📄',
  value: '300+',
  label: 'Pages'
}, {
  emoji: '🗂',
  value: '6',
  label: 'Operating volumes'
}, {
  emoji: '⏱',
  value: 'Minute-by-minute',
  label: 'Day-of timeline'
}, {
  emoji: '🧰',
  value: '40+',
  label: 'Scripts, templates & checklists'
}];
const coverage = ['Sales & Onboarding', 'Budget & Logistics', 'Design', 'Vendor Management', 'Wedding Day Execution', 'Profit & Referrals'];
export function ProductReveal() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-198" data-mp="28eb3kfvj3cka">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-199" data-mp="28fuk87l3jpml">
        <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-ink-soft" data-id="element-200" data-mp="2n3pe3rauc019">
          🏆 The complete operating system for wedding planners
        </span>

        <h2 className="mt-8 font-serif text-4xl sm:text-6xl text-ink" data-id="element-201" data-mp="1ulbnocru3gc7">
          The Wedding Pro OS™
        </h2>
        <p className="mx-auto mt-5 max-w-3xl font-serif text-xl italic sm:text-2xl text-gold-dark" data-id="element-202" data-mp="1plpa2283fy2v">
          6 Volumes + 5 Bonuses — From First Inquiry to Flawless Execution to Referrals on
          Repeat
        </p>

        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-203" data-mp="1jt9ay93lb6jz" />

        <p className="mx-auto mt-8 max-w-3xl text-base sm:text-lg leading-relaxed text-ink-soft" data-id="element-204" data-mp="1ju14ledmmu7m">
          This is not a course. Not &ldquo;tips&rdquo;. Not another Pinterest board.
          It&rsquo;s the complete business — packaged. 300+ pages of scripts, frameworks,
          checklists and protocols that luxury planners never share.
        </p>

        <ul className="mt-12 grid grid-cols-2 gap-px overflow-hidden border border-gold-soft bg-gold-soft sm:grid-cols-4" data-id="element-205" data-mp="112i4bfazlu9a">
          {stats.map(stat => <li key={stat.label} className="bg-ivory px-4 py-7" data-id="element-206" data-mp="15zi272xonqpb">
              <div aria-hidden="true" className="text-lg" data-id="element-207" data-mp="2chew2wyk2xkc">
                {stat.emoji}
              </div>
              <div className="mt-2 font-serif text-xl text-ink" data-id="element-208" data-mp="2hf6nzqz7ajoj">{stat.value}</div>
              <div className="mt-1 text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-209" data-mp="1rrkpm7yw1nnq">
                {stat.label}
              </div>
            </li>)}
        </ul>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2.5" data-id="element-210" data-mp="21rbo0kqkkmt3">
          {coverage.map(item => <li key={item} className="rounded-full border border-ink/10 px-4 py-1.5 text-xs tracking-wide text-ink-soft" data-id="element-211" data-mp="1wta1fptxq5cv">
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}